module.exports = __webpack_public_path__ + "img/product_sk-ii_2@2x.9064e52a.png";